import { render, staticRenderFns } from "./RelationInfoItem.vue?vue&type=template&id=4453be9e&scoped=true"
import script from "./RelationInfoItem.vue?vue&type=script&lang=js"
export * from "./RelationInfoItem.vue?vue&type=script&lang=js"
import style0 from "./RelationInfoItem.vue?vue&type=style&index=0&id=4453be9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4453be9e",
  null
  
)

export default component.exports